import React from "react";
import { Redirect } from "react-router-dom";

import { useSkillManagementModal } from "../../table/hooks/use_skill_management_modal";
import { EditSkillModal } from "./edit";
import { ImportSkillsModal } from "./import";
import { ImportModalPage } from "./import/constants/import_modal_page";
import { SkillsManagementModalType } from "./import/constants/skills_management_modal_type";
import { MergeSkillModal } from "./merge";

export const SkillsManagementModal = ({
  modalPage,
  importPage
}: {
  modalPage: SkillsManagementModalType;
  importPage?: ImportModalPage;
}): React.ReactElement | null => {
  const { closeModal, modalData } = useSkillManagementModal();

  switch (modalPage) {
    case "create":
      return <EditSkillModal onClose={() => closeModal()} />;
    case "edit":
      if (modalData.skills && modalData.skills[0]) {
        return <EditSkillModal onClose={() => closeModal()} skill={modalData.skills![0]} />;
      }
      return <Redirect to={"/admin/skills_management"} />;
    case "merge":
      return <MergeSkillModal />;
    case "import":
      return <ImportSkillsModal initialPage={importPage} />;
    default:
      return null;
  }
};
